<template>
  <v-app>
    <TopBar />
    <router-view></router-view>
    <Loading />
  </v-app>
</template>

<script>
import TopBar from './TopBar.vue';
import Loading from "@/components/utils/Loading";

export default {
  components: { TopBar, Loading }
}
</script>

<style>

</style>
